/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "eventmanagerAdminApi",
            "endpoint": "https://d3o6alpx19.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        },
        {
            "name": "eventmanagerPublicApi",
            "endpoint": "https://d6az88azc4.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        },
        {
            "name": "eventmanagerUserApi",
            "endpoint": "https://kmzqksxu54.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:5a875b39-0538-43d9-a178-667d670bce02",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_MBdilFm9v",
    "aws_user_pools_web_client_id": "2curo6go5ur0887n931v1539i1",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "eventmanager-20190702215102-hostingbucket-master",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "http://eventmanager-20190702215102-hostingbucket-master.s3-website-eu-west-1.amazonaws.com",
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "eventmanagerCeos-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerCompanies-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerEventGuests-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerEventHosts-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerEventMailLog-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerEventTemplates-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerEvents-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerGroupGuests-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerGroups-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerGuestLogs-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerGuests-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerHosts-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerTrainingCeos-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerTrainingGuests-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerTrainingTemplates-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "eventmanagerTrainings-master",
            "region": "eu-west-1"
        }
    ],
    "aws_user_files_s3_bucket": "eventmanagerf70d9528645348798e16449e0b1f7309-master",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
